var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResidenceHallStat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aea0e2b7-1605-4065-b0a1-1e5ff5622cf2",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.81 165.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 121.69)",
    style: {
      fontSize: 146,
      fill: "#ab4a9c",
      fontFamily: "futura-pt",
      fontWeight: 700
    }
  }, "7"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(5 126.37)",
    style: {
      fontSize: 146,
      fill: "none",
      stroke: "#002b51",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fontFamily: "futura-pt",
      fontWeight: 700
    }
  }, "7"));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidenceHallStat);
export default __webpack_public_path__ + "static/media/residence-hall-stat.74e74fda0a00ab2593c9b52127c34b35.svg";
export { ForwardRef as ReactComponent };